/**
 * @fileoverview gRPC-Web generated client stub for mycargo.projects.erp.api.v1.services
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.12.4
// source: projects/erp/service/api/v1/services/chines_orders.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var projects_erp_service_api_v1_model_chines_order_pb = require('./chines_order_pb.js')
const proto = {};
proto.mycargo = {};
proto.mycargo.projects = {};
proto.mycargo.projects.erp = {};
proto.mycargo.projects.erp.api = {};
proto.mycargo.projects.erp.api.v1 = {};
proto.mycargo.projects.erp.api.v1.services = require('./chines_orders_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.mycargo.projects.erp.api.v1.services.ChinesOrdersClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.mycargo.projects.erp.api.v1.services.ChinesOrdersPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mycargo.projects.erp.api.v1.services.ListChinesOrdersRequest,
 *   !proto.mycargo.projects.erp.api.v1.services.ListChinesOrdersResponse>}
 */
const methodDescriptor_ChinesOrders_ListChinesOrders = new grpc.web.MethodDescriptor(
  '/mycargo.projects.erp.api.v1.services.ChinesOrders/ListChinesOrders',
  grpc.web.MethodType.UNARY,
  proto.mycargo.projects.erp.api.v1.services.ListChinesOrdersRequest,
  proto.mycargo.projects.erp.api.v1.services.ListChinesOrdersResponse,
  /**
   * @param {!proto.mycargo.projects.erp.api.v1.services.ListChinesOrdersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mycargo.projects.erp.api.v1.services.ListChinesOrdersResponse.deserializeBinary
);


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.ListChinesOrdersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mycargo.projects.erp.api.v1.services.ListChinesOrdersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mycargo.projects.erp.api.v1.services.ListChinesOrdersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mycargo.projects.erp.api.v1.services.ChinesOrdersClient.prototype.listChinesOrders =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.ChinesOrders/ListChinesOrders',
      request,
      metadata || {},
      methodDescriptor_ChinesOrders_ListChinesOrders,
      callback);
};


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.ListChinesOrdersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mycargo.projects.erp.api.v1.services.ListChinesOrdersResponse>}
 *     Promise that resolves to the response
 */
proto.mycargo.projects.erp.api.v1.services.ChinesOrdersPromiseClient.prototype.listChinesOrders =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.ChinesOrders/ListChinesOrders',
      request,
      metadata || {},
      methodDescriptor_ChinesOrders_ListChinesOrders);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mycargo.projects.erp.api.v1.services.GetChinesOrderRequest,
 *   !proto.mycargo.projects.erp.api.v1.model.ChinesOrder>}
 */
const methodDescriptor_ChinesOrders_GetChinesOrder = new grpc.web.MethodDescriptor(
  '/mycargo.projects.erp.api.v1.services.ChinesOrders/GetChinesOrder',
  grpc.web.MethodType.UNARY,
  proto.mycargo.projects.erp.api.v1.services.GetChinesOrderRequest,
  projects_erp_service_api_v1_model_chines_order_pb.ChinesOrder,
  /**
   * @param {!proto.mycargo.projects.erp.api.v1.services.GetChinesOrderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  projects_erp_service_api_v1_model_chines_order_pb.ChinesOrder.deserializeBinary
);


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.GetChinesOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mycargo.projects.erp.api.v1.model.ChinesOrder)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mycargo.projects.erp.api.v1.model.ChinesOrder>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mycargo.projects.erp.api.v1.services.ChinesOrdersClient.prototype.getChinesOrder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.ChinesOrders/GetChinesOrder',
      request,
      metadata || {},
      methodDescriptor_ChinesOrders_GetChinesOrder,
      callback);
};


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.GetChinesOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mycargo.projects.erp.api.v1.model.ChinesOrder>}
 *     Promise that resolves to the response
 */
proto.mycargo.projects.erp.api.v1.services.ChinesOrdersPromiseClient.prototype.getChinesOrder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.ChinesOrders/GetChinesOrder',
      request,
      metadata || {},
      methodDescriptor_ChinesOrders_GetChinesOrder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mycargo.projects.erp.api.v1.services.CreateChinesOrderRequest,
 *   !proto.mycargo.projects.erp.api.v1.model.ChinesOrder>}
 */
const methodDescriptor_ChinesOrders_CreateChinesOrder = new grpc.web.MethodDescriptor(
  '/mycargo.projects.erp.api.v1.services.ChinesOrders/CreateChinesOrder',
  grpc.web.MethodType.UNARY,
  proto.mycargo.projects.erp.api.v1.services.CreateChinesOrderRequest,
  projects_erp_service_api_v1_model_chines_order_pb.ChinesOrder,
  /**
   * @param {!proto.mycargo.projects.erp.api.v1.services.CreateChinesOrderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  projects_erp_service_api_v1_model_chines_order_pb.ChinesOrder.deserializeBinary
);


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.CreateChinesOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mycargo.projects.erp.api.v1.model.ChinesOrder)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mycargo.projects.erp.api.v1.model.ChinesOrder>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mycargo.projects.erp.api.v1.services.ChinesOrdersClient.prototype.createChinesOrder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.ChinesOrders/CreateChinesOrder',
      request,
      metadata || {},
      methodDescriptor_ChinesOrders_CreateChinesOrder,
      callback);
};


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.CreateChinesOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mycargo.projects.erp.api.v1.model.ChinesOrder>}
 *     Promise that resolves to the response
 */
proto.mycargo.projects.erp.api.v1.services.ChinesOrdersPromiseClient.prototype.createChinesOrder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.ChinesOrders/CreateChinesOrder',
      request,
      metadata || {},
      methodDescriptor_ChinesOrders_CreateChinesOrder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mycargo.projects.erp.api.v1.services.UpdateChinesOrderRequest,
 *   !proto.mycargo.projects.erp.api.v1.model.ChinesOrder>}
 */
const methodDescriptor_ChinesOrders_UpdateChinesOrder = new grpc.web.MethodDescriptor(
  '/mycargo.projects.erp.api.v1.services.ChinesOrders/UpdateChinesOrder',
  grpc.web.MethodType.UNARY,
  proto.mycargo.projects.erp.api.v1.services.UpdateChinesOrderRequest,
  projects_erp_service_api_v1_model_chines_order_pb.ChinesOrder,
  /**
   * @param {!proto.mycargo.projects.erp.api.v1.services.UpdateChinesOrderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  projects_erp_service_api_v1_model_chines_order_pb.ChinesOrder.deserializeBinary
);


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.UpdateChinesOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mycargo.projects.erp.api.v1.model.ChinesOrder)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mycargo.projects.erp.api.v1.model.ChinesOrder>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mycargo.projects.erp.api.v1.services.ChinesOrdersClient.prototype.updateChinesOrder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.ChinesOrders/UpdateChinesOrder',
      request,
      metadata || {},
      methodDescriptor_ChinesOrders_UpdateChinesOrder,
      callback);
};


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.UpdateChinesOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mycargo.projects.erp.api.v1.model.ChinesOrder>}
 *     Promise that resolves to the response
 */
proto.mycargo.projects.erp.api.v1.services.ChinesOrdersPromiseClient.prototype.updateChinesOrder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.ChinesOrders/UpdateChinesOrder',
      request,
      metadata || {},
      methodDescriptor_ChinesOrders_UpdateChinesOrder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mycargo.projects.erp.api.v1.services.DeleteChinesOrderRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ChinesOrders_DeleteChinesOrder = new grpc.web.MethodDescriptor(
  '/mycargo.projects.erp.api.v1.services.ChinesOrders/DeleteChinesOrder',
  grpc.web.MethodType.UNARY,
  proto.mycargo.projects.erp.api.v1.services.DeleteChinesOrderRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.mycargo.projects.erp.api.v1.services.DeleteChinesOrderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.DeleteChinesOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mycargo.projects.erp.api.v1.services.ChinesOrdersClient.prototype.deleteChinesOrder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.ChinesOrders/DeleteChinesOrder',
      request,
      metadata || {},
      methodDescriptor_ChinesOrders_DeleteChinesOrder,
      callback);
};


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.DeleteChinesOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.mycargo.projects.erp.api.v1.services.ChinesOrdersPromiseClient.prototype.deleteChinesOrder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.ChinesOrders/DeleteChinesOrder',
      request,
      metadata || {},
      methodDescriptor_ChinesOrders_DeleteChinesOrder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mycargo.projects.erp.api.v1.services.ListChinesOrderPaymentsRequest,
 *   !proto.mycargo.projects.erp.api.v1.services.ListChinesOrderPaymentsResponse>}
 */
const methodDescriptor_ChinesOrders_ListChinesOrderPayments = new grpc.web.MethodDescriptor(
  '/mycargo.projects.erp.api.v1.services.ChinesOrders/ListChinesOrderPayments',
  grpc.web.MethodType.UNARY,
  proto.mycargo.projects.erp.api.v1.services.ListChinesOrderPaymentsRequest,
  proto.mycargo.projects.erp.api.v1.services.ListChinesOrderPaymentsResponse,
  /**
   * @param {!proto.mycargo.projects.erp.api.v1.services.ListChinesOrderPaymentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mycargo.projects.erp.api.v1.services.ListChinesOrderPaymentsResponse.deserializeBinary
);


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.ListChinesOrderPaymentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mycargo.projects.erp.api.v1.services.ListChinesOrderPaymentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mycargo.projects.erp.api.v1.services.ListChinesOrderPaymentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mycargo.projects.erp.api.v1.services.ChinesOrdersClient.prototype.listChinesOrderPayments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.ChinesOrders/ListChinesOrderPayments',
      request,
      metadata || {},
      methodDescriptor_ChinesOrders_ListChinesOrderPayments,
      callback);
};


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.ListChinesOrderPaymentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mycargo.projects.erp.api.v1.services.ListChinesOrderPaymentsResponse>}
 *     Promise that resolves to the response
 */
proto.mycargo.projects.erp.api.v1.services.ChinesOrdersPromiseClient.prototype.listChinesOrderPayments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.ChinesOrders/ListChinesOrderPayments',
      request,
      metadata || {},
      methodDescriptor_ChinesOrders_ListChinesOrderPayments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mycargo.projects.erp.api.v1.services.CreateChinesOrderPaymentRequest,
 *   !proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment>}
 */
const methodDescriptor_ChinesOrders_CreateChinesOrderPayment = new grpc.web.MethodDescriptor(
  '/mycargo.projects.erp.api.v1.services.ChinesOrders/CreateChinesOrderPayment',
  grpc.web.MethodType.UNARY,
  proto.mycargo.projects.erp.api.v1.services.CreateChinesOrderPaymentRequest,
  projects_erp_service_api_v1_model_chines_order_pb.ChinesOrderPayment,
  /**
   * @param {!proto.mycargo.projects.erp.api.v1.services.CreateChinesOrderPaymentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  projects_erp_service_api_v1_model_chines_order_pb.ChinesOrderPayment.deserializeBinary
);


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.CreateChinesOrderPaymentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mycargo.projects.erp.api.v1.services.ChinesOrdersClient.prototype.createChinesOrderPayment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.ChinesOrders/CreateChinesOrderPayment',
      request,
      metadata || {},
      methodDescriptor_ChinesOrders_CreateChinesOrderPayment,
      callback);
};


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.CreateChinesOrderPaymentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment>}
 *     Promise that resolves to the response
 */
proto.mycargo.projects.erp.api.v1.services.ChinesOrdersPromiseClient.prototype.createChinesOrderPayment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.ChinesOrders/CreateChinesOrderPayment',
      request,
      metadata || {},
      methodDescriptor_ChinesOrders_CreateChinesOrderPayment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mycargo.projects.erp.api.v1.services.UpdateChinesOrderPaymentRequest,
 *   !proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment>}
 */
const methodDescriptor_ChinesOrders_UpdateChinesOrderPayment = new grpc.web.MethodDescriptor(
  '/mycargo.projects.erp.api.v1.services.ChinesOrders/UpdateChinesOrderPayment',
  grpc.web.MethodType.UNARY,
  proto.mycargo.projects.erp.api.v1.services.UpdateChinesOrderPaymentRequest,
  projects_erp_service_api_v1_model_chines_order_pb.ChinesOrderPayment,
  /**
   * @param {!proto.mycargo.projects.erp.api.v1.services.UpdateChinesOrderPaymentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  projects_erp_service_api_v1_model_chines_order_pb.ChinesOrderPayment.deserializeBinary
);


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.UpdateChinesOrderPaymentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mycargo.projects.erp.api.v1.services.ChinesOrdersClient.prototype.updateChinesOrderPayment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.ChinesOrders/UpdateChinesOrderPayment',
      request,
      metadata || {},
      methodDescriptor_ChinesOrders_UpdateChinesOrderPayment,
      callback);
};


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.UpdateChinesOrderPaymentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment>}
 *     Promise that resolves to the response
 */
proto.mycargo.projects.erp.api.v1.services.ChinesOrdersPromiseClient.prototype.updateChinesOrderPayment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.ChinesOrders/UpdateChinesOrderPayment',
      request,
      metadata || {},
      methodDescriptor_ChinesOrders_UpdateChinesOrderPayment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mycargo.projects.erp.api.v1.services.DeleteChinesOrderPaymentRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ChinesOrders_DeleteChinesOrderPayment = new grpc.web.MethodDescriptor(
  '/mycargo.projects.erp.api.v1.services.ChinesOrders/DeleteChinesOrderPayment',
  grpc.web.MethodType.UNARY,
  proto.mycargo.projects.erp.api.v1.services.DeleteChinesOrderPaymentRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.mycargo.projects.erp.api.v1.services.DeleteChinesOrderPaymentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.DeleteChinesOrderPaymentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mycargo.projects.erp.api.v1.services.ChinesOrdersClient.prototype.deleteChinesOrderPayment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.ChinesOrders/DeleteChinesOrderPayment',
      request,
      metadata || {},
      methodDescriptor_ChinesOrders_DeleteChinesOrderPayment,
      callback);
};


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.DeleteChinesOrderPaymentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.mycargo.projects.erp.api.v1.services.ChinesOrdersPromiseClient.prototype.deleteChinesOrderPayment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.ChinesOrders/DeleteChinesOrderPayment',
      request,
      metadata || {},
      methodDescriptor_ChinesOrders_DeleteChinesOrderPayment);
};


module.exports = proto.mycargo.projects.erp.api.v1.services;
